export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: !that.disabled,
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    showHeaderOverflow: true,
    slots: { default: 'opt' },
  },
  {
    field: 'defaultImageUrl',
    width: 70,
    title: that.$l('INDEX.table_label_image') || '图片',
    headerAlign: 'left',
    align: 'left',
    fixed: 'left',
    slots: { default: 'defaultImage' },
  },
  {
    title: that.$l('table_label_displaySku') || '产品信息',
    field: 'displaySku',
    headerAlign: 'left',
    align: 'left',
    fixed: 'left',
    minWidth: 220,
    slots: { default: 'displaySku' },
  },
  {
    title: that.$l('table_label_displayStore') || '销售信息',
    field: 'displayStore',
    headerAlign: 'left',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    slots: { default: 'displayStore' },
  },
  {
    title: that.$l('table_label_displaySubmitQty') || '补货数量',
    field: 'displaySubmitQty',
    headerAlign: 'left',
    align: 'left',
    minWidth: 120,
    showHeaderOverflow: true,
    slots: { default: 'displaySubmitQty' },
  },
  {
    title: that.$l('table_label_displayInv') || '库存信息',
    field: 'displayInv',
    headerAlign: 'left',
    align: 'left',
    minWidth: 220,
    showHeaderOverflow: true,
    slots: { default: 'displayInv' },
    visible: that.isVc == 'N',
  },
  {
    title: that.$l('table_label_displayOperate') || '运营信息',
    field: 'displayOperate',
    headerAlign: 'left',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
    slots: { default: 'displayOperate' },
    visible: that.isVc == 'N',
  },
  {
    title: that.$l('table_label_displayDaySalesVolume') || '日销售量',
    field: 'displayDaySalesVolume',
    headerAlign: 'left',
    align: 'left',
    minWidth: 150,
    showHeaderOverflow: true,
    slots: { default: 'displayDaySalesVolume' },
    visible: that.isVc == 'N',
  },
  {
    title: that.$l('table_label_requestComments') || '备注',
    field: 'requestComments',
    align: 'left',
    minWidth: 200,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_approvalStatus') || '审批状态',
    field: 'approvalStatus',
    minWidth: 210,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_modifyInfo') || '修改人',
    field: 'modifyByName',
    align: 'left',
    minWidth: 170,
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
